import { Dialog } from '@kobalte/core/dialog'
import { Spinner } from './ui/spinner'

export function LoadingOverlay(props: { isOpen: boolean }) {
  return (
    <Dialog open={props.isOpen}>
      <Dialog.Portal>
        <Dialog.Content
          class="fixed inset-0 z-[100] grid place-items-center bg-black/50 data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[expanded]:fade-in-0"
          onOpenAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <Spinner class="size-6" />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
